module.exports = "pegasus/assets/themelp1/app/102.png";